import * as _ from 'lodash';
import { Formatter } from 'slickgrid';

export interface GetvalueFormatterOptions {
  field: string;
  source?: 'row' | 'value';
  separator?: string;
}

export function getvalue<T>(opts: GetvalueFormatterOptions): Formatter<T> {
  const source = opts.source || 'row';
  const separator = opts.separator || ' ';

  let result: Formatter<T>;

  if (source === 'row') {
    function getvalueFromRowFormatter(row, cell, value, columnDef, data, grid) {
      return _.get(data, opts.field, '') as string;
    }

    getvalueFromRowFormatter.exportDataFormatter = getvalueFromRowFormatter;

    return getvalueFromRowFormatter;
  }

  function getvalueFormatter(row, cell, value, columnDef, data, grid) {
    if (_.includes(opts.field, ',')) {
      return (
        _.chain(opts.field.split(','))
          .map((val) => _.get(value, val.trim(), null))
          .filter((val) => !_.isEmpty(val))
          .join(separator)
          .value() || ('' as string)
      );
    }

    return _.get(value, opts.field, '') as string;
  }

  getvalueFormatter.exportDataFormatter = getvalueFormatter;

  return getvalueFormatter;
}
